export default __webpack_public_path__ + "static/media/buttons-card-1.c338b2c0.svg";